import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios';
Vue.prototype.$http = axios;
Vue.config.productionTip = false
import VueRecord from '@codekraft-studio/vue-record'

Vue.use(VueRecord)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
